import type { SVGProps } from 'react'

export default function ChevronDownSmall(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M2.5 4L6 8L9.5 4" stroke="currentColor" />
		</svg>
	)
}
